import * as React from 'react';

const SvgContact = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.12}>
      <path
        d="M12.1894 12.9563C11.0339 14.018 9.5053 14.6641 7.82907 14.6641C6.15284 14.6641 4.62426 14.018 3.46875 12.9563C3.86561 12.0009 4.79219 11.3307 5.87193 11.3307H9.78621C10.866 11.3307 11.7925 12.0009 12.1894 12.9563Z"
        fill="currentColor"
      />
      <path
        d="M7.829 8.9974C9.2702 8.9974 10.4385 7.80349 10.4385 6.33073C10.4385 4.85797 9.2702 3.66406 7.829 3.66406C6.3878 3.66406 5.21948 4.85797 5.21948 6.33073C5.21948 7.80349 6.3878 8.9974 7.829 8.9974Z"
        fill="currentColor"
      />
    </g>
    <path
      d="M3.46817 12.9615C3.86503 12.0061 4.79161 11.3359 5.87135 11.3359H9.78564C10.8654 11.3359 11.792 12.0061 12.1888 12.9615M10.438 6.33594C10.438 7.8087 9.26969 9.0026 7.8285 9.0026C6.3873 9.0026 5.21897 7.8087 5.21897 6.33594C5.21897 4.86318 6.3873 3.66927 7.8285 3.66927C9.26969 3.66927 10.438 4.86318 10.438 6.33594ZM14.3523 8.0026C14.3523 11.6845 11.4315 14.6693 7.8285 14.6693C4.2255 14.6693 1.30469 11.6845 1.30469 8.0026C1.30469 4.32071 4.2255 1.33594 7.8285 1.33594C11.4315 1.33594 14.3523 4.32071 14.3523 8.0026Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgContact;
